
/**
 * 메시지 상태 정보
 */
export type ChatMessageSummaryStatus = {
  isRead?: boolean;
};
